export default "__VITE_ASSET__BGKXIFrg__"